<template>
  <div
    v-show="isActive"
    ref="dropBox"
    class="dropBox"
  >
    <div class="tip1">
      将视频拖拽到此处
    </div>
    <div class="tip2">
      最多支持5个视频
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropBox',
  components: {},
  props: {},
  data() {
    return {
      isActive: false,
      enterElemetnNode: null
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.registerDrop();
  },
  beforeDestroy() {
    this.unRegisterDrop();
  },
  methods: {
    drop(e) {
      e.stopPropagation();
      e.preventDefault();
      this.isActive = false;
      this.$emit('dropFiles', e.dataTransfer.files);
    },
    dragenter(e) {
      this.enterElemetnNode = e.target;
      e.stopPropagation();
      e.preventDefault();
      this.isActive = true;
    },
    dragleave(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.enterElemetnNode == e.target) {
        this.isActive = false;
      }
    },
    dragover(e) {
      e.stopPropagation();
      e.preventDefault();
      //this.isActive = true;
    },
    registerDrop() {
      this.$refs.dropBox.addEventListener('drop', this.drop, false);
      window.addEventListener('dragenter', this.dragenter, false);
      window.addEventListener('dragleave', this.dragleave, false);
      window.addEventListener('dragover', this.dragover, false);
    },
    unRegisterDrop() {
      this.$refs.dropBox.removeEventListener('drop', this.drop, false);
      window.removeEventListener('dragenter', this.dragenter);
      window.removeEventListener('dragleave', this.dragleave);
      window.removeEventListener('dragover', this.dragover);
    }
  }
};
</script>

<style scoped lang="scss">
.dropBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  //@debug opacity: 0.8;
  border-radius: 4px;
  z-index: 999;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .tip1 {
    font-weight: bold;
    color: #f6f7fb;
    font-size: 36px;
    text-align: center;
    line-height: 36px;
    height: 36px;
  }
  .tip2 {
    font-size: 18px;
    color: #f6f7fb;
    text-align: center;
    height: 19px;
    line-height: 19px;
    margin-top: 16px;
  }
}
</style>
